import { Get, Post, Put, Delete } from '../../api/axiosCoreConfig';
import { createQueryParamsFromObject } from '../../api/helper';

export const searchDrugs = ({ name = '', offset = 0, limit = 10, namespace }) =>
    Get('/drug', { params: createQueryParamsFromObject({ name, offset, limit, namespace }) });
export const createPrescription = (prescription) => Post('/drug/prescription', prescription);
export const editPrescription = (id, prescription) => Put(`/drug/prescription/${id}`, prescription);
export const deletePrescription = (id, namespace) =>
    Delete(`/drug/prescription/${id}?namespace=${namespace}`);
export const getAllPrescriptionOfPatient = (patientId, namespace) =>
    Get(`/drug/prescription?patient_id=${patientId}&namespace=${namespace}`);
export const getDrugsDetail = (ids, namespace) =>
    Get(`/drug/list?drug_ids=${ids}&namespace=${namespace}`);
